import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20landscape%20with%20flowing%20gradient%20waves%20in%20warm%20coral%20and%20teal%20tones%2C%20soft%20geometric%20shapes%20floating%2C%20minimalist%20clean%20design%2C%20subtle%20grid%20pattern%2C%20ethereal%20atmosphere%20with%20gentle%20light%20particles%2C%20sophisticated%20tech%20aesthetic%20with%20organic%20flowing%20lines%2C%208k%20quality%20digital%20art&width=1800&height=900&seq=hero-bg-17c&orientation=landscape"
          alt="17c.cc 官方入口背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <i className="ri-verified-badge-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
          <span className="text-sm text-background-50 font-medium">17c.cc 官方认证入口</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          17c.cc – 官方入口与核心功能全解析
        </h1>

        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          17c.cc 是您不可错过的优质平台。我们为您提供完整的官方入口导航、详细的使用指南、全面的功能介绍及常见问题解答，帮助每一位用户快速上手，享受流畅便捷的在线体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/guide"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-guide-line mr-2"></i>
            查看使用指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>
            了解 17c.cc
          </Link>
        </div>
      </div>
    </section>
  );
}